module.exports = __webpack_public_path__ + "img/odo-vertical-white.5e8cf3b5.png";